import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  ModalOverlay,
  ModalContainer,
  IconContainer,
  CheckIcon,
  Title,
  Subtitle,
  ModalMessageInfo,
  HistoryLinkContainer,
  HistoryLink,
  CloseButton
} from './styles';

import checkGreenIcon from '../../assets/images/check_green.svg';

const ResponseRegisteredModal = ({ isOpen, onClose, source }) => {
  const history = useHistory();

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>
          ✕
        </CloseButton>

        <IconContainer>
          <CheckIcon src={checkGreenIcon} alt="Resposta registrada" />
        </IconContainer>

        <Title>Resposta registrada</Title>

        <Subtitle>
          Agradecemos seu feedback! Ele nos ajuda a melhorar
          continuamente as próximas visitas.
        </Subtitle>
        <ModalMessageInfo>
          {source !== 'HistoryVisits' && (
            <>
              Você também poderá acessar o histórico de visitas em:<br />
              <HistoryLinkContainer>
                Minha conta &gt;
                <HistoryLink onClick={() => history.push('/historico-visitas')}>
                  {' '}Histórico de visitas
                </HistoryLink>
              </HistoryLinkContainer>
            </>
          )}
        </ModalMessageInfo>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ResponseRegisteredModal;
